import localeAntd from 'antd/es/locale/en_US';

import ClientType from 'constants/clientType';
import CopyrightClient from 'constants/copyrightClient';

const topBar = {
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',
};

const login = {
  'login.title': 'Login',
  'login.form.title': 'Sign in to your account',
  'login.form.submitBtn': 'Sign in',
  'login.form.item.email.placeholder': 'Email',
  'login.form.password': 'Password',
  'login.form.validation.email.required': 'Please enter your email',
  'login.form.validation.password.required': 'Please enter your password',
};

const mainMenu = {
  'main.menu.left.home': 'Home',
  'main.menu.left.campaign': 'Campaign',
  'main.menu.left.members': 'Members',
  'main.menu.left.winners': 'Winners',
};

const campaigns = {
  'campaigns.title': 'Campaigns',
  'campaigns.header.new': 'New Campaign',
  'campaigns.table.header.title': 'Title',
  'campaigns.table.header.description': 'Description',
  'campaigns.table.header.gifts': 'Gifts',
  'campaigns.table.header.validFrom': 'Valid from',
  'campaigns.table.header.validTo': 'Valid to',
  'campaigns.table.header.published': 'Published',
  'campaigns.table.header.active': 'Active',
  'campaigns.table.emptyText': 'No Campaigns',
  'campaigns.table.popover.unpublish': 'Are you sure you want to unpublish this campaign?',
  'campaigns.table.popover.publish': 'Are you sure you want to publish this campaign?',
  'campaigns.table.popover.okText': 'Yes',
  'campaigns.table.popover.cancelText': 'No',
  'campaigns.notification.fetch.error':
    'There was an error fetching the campaign, please try again',
};

const campaign = {
  'campaign.details.title': 'Campaign Details',
  'campaign.reports.title': 'Campaign Reports',
  'campaign.new.title': 'New Campaign',
  'campaign.button.save': 'Save',
  'campaign.button.create': 'Create',
  'campaign.form.validation.title.required': 'Campaign Name is required',
  'campaign.form.validation.description.required': 'Description is required',
  'campaign.form.validation.validFrom.required': 'Date is required',
  'campaign.form.validation.validTo.required': 'Date is required',
  'campaign.form.item.title.label': 'Campaign Name',
  'campaign.form.item.image.label': 'Campaign Poster',
  'campaign.form.item.validFrom.label': 'Start Date',
  'campaign.form.item.validTo.label': 'End Date',
  'campaign.form.item.description.label': 'Campaign Description',
  'campaign.table.header.title': 'Title',
  'campaign.table.header.magicNumber': 'Magic Number',
  'campaign.table.header.remaining': 'Remaining',
  'campaign.table.header.initial': 'Total',
  'campaign.table.header.active': 'Active',
  'campaign.table.title': 'Campaign Gifts',
  'campaign.table.emptyText': 'No Gifts',
  'campaign.table.popover.title': 'Are you sure you want to delete this gift?',
  'campaign.table.popover.okText': 'Yes',
  'campaign.table.popover.cancelText': 'No',
  'campaign.gift.form.item.name.label': 'Name',
  'campaign.gift.form.item.image.label': 'Photo',
  'campaign.gift.form.item.description.label': 'Description',
  'campaign.gift.form.item.magicNumber.label': 'Magic Number',
  'campaign.gift.form.item.totalGifts.label': 'Total Gifts',
  'campaign.gift.form.item.name.placeholder': 'Enter gift name',
  'campaign.gift.form.item.description.placeholder': 'Enter description',
  'campaign.gift.form.item.magicNumber.placeholder': 'Enter magic number',
  'campaign.gift.form.item.totalGifts.placeholder': 'Enter number of gifts',
  'campaign.gift.form.validation.title.required': 'Gift Name is required',
  'campaign.gift.form.validation.magicNumber.required': 'Magic number is required',
  'campaign.gift.form.validation.magicNumber.onlyNumbers':
    'Magic number should contain only numbers',
  'campaign.gift.form.validation.totalGifts.required': 'Total is required',
  'campaign.gift.form.validation.totalGifts.onlyNumbers': 'Total should contain only numbers',
  'campaign.gift.button.save': 'Save',
  'campaign.gift.button.cancel': 'Cancel',
  'campaign.gift.details.title': 'Gift Details',
  'campaign.gift.new.title': 'New Gift',
  'campaign.qrcode.form.item.amount.placeholder': 'Codes Amount',
  'campaign.qrcode.form.item.pin.placeholder': 'Pin',
  'campaign.qrcode.form.validation.amount.required': 'Amount is required',
  'campaign.qrcode.form.validation.pin.required': 'Pin is required',
  'campaign.qrcode.form.validation.amount.max': 'Amount should be less than 1 million',
  'campaign.qrcode.form.validation.amount.onlyNumbers': 'Amount should contain only numbers',
  'campaign.qrcode.form.validation.pin.valid': 'Please enter valid pin',
  'campaign.qrcode.button.generate': 'Generate',
  'campaign.qrcode.button.cancel': 'Cancel',
  'campaign.qrcode.title': 'Campaign QR Codes Generation',
  'campaign.loosers.button.generate': 'Generate Loosers',
  'campaign.notification.success.title': 'Success',
  'campaign.notification.error.title': 'Error',
  'campaign.notification.edit.success': 'Campaign was edited successfully',
  'campaign.notification.edit.error': 'There was an error editing the campaign, please try again',
  'campaign.notification.save.success': 'Campaign was added successfully',
  'campaign.notification.save.error': 'There was an error adding the campaign, please try again',
  'campaign.notification.fetch.error': 'There was an error fetching the campaign, please try again',
  'campaign.notification.load.error': 'There was an error loading the campaign, please try again',
  'campaign.notification.load.gift.error':
    'There was an error loading the campaign gift, please try again',
  'campaign.notification.save.gift.error':
    'There was an error saving the campaign gift, please try again',
  'campaign.notification.load.gifts.error':
    'There was an error loading the campaign gifts, please try again',
  'campaign.notification.publish.error':
    'There was an error publishing the campaign, please try again',
  'campaign.notification.unpublish.error':
    'There was an error unpublishing the campaign, please try again',
  'campaign.notification.generation.success': 'Generation was successful',
  'campaign.notification.generation.error': 'Generation failed, please try again',
  'campaign.notification.delete.error': 'Campaign Gift deletion failed, please try again',
  'campaign.notification.magicNumber.error':
    'The magic number for this gift is already taken, please try another one',
  'campaign.notification.dateFromGreaterThanDateTo.error':
    'Date from cannot be greater than date to',
};

const reports = {
  'reports.title': 'Reports',
  'reports.campaign.gifts.table.title': 'Campaign Gifts',
  'reports.campaign.gifts.table.emptyText': 'No Gifts',
  'reports.campaign.gifts.table.columns.title': 'Title',
  'reports.campaign.gifts.table.columns.remaining': 'Remaining',
  'reports.campaign.gifts.table.columns.totalWon': 'Total Won',
  'reports.campaign.gifts.table.winner.title': 'Winners',
  'reports.campaign.gifts.table.winner.table.name': 'Name',
  'reports.campaign.gifts.table.winner.table.phoneNumber': 'Phone Number',
  'reports.campaign.coupons.filterForm.from.placeholder': 'From',
  'reports.campaign.coupons.filterForm.to.placeholder': 'To',
  'reports.campaign.coupons.filterForm.button': 'Export Coupons',
  'reports.campaign.coupons.filterForm.validation.from.required': 'From is required',
  'reports.campaign.coupons.filterForm.validation.to.required': 'To is required',
  'reports.campaign.coupons.filterForm.validation.fromIsGreater':
    'Date from cannot be greater than date to',
  'reports.campaign.gifts.notification.fetch.error':
    'There was an error fetching the campaign gifts, please try again',
  'reports.campaign.gifts.winners.notification.fetch.error':
    'There was an error fetching gift winners, please try again',
  'reports.campaign.coupons.notification.export.error':
    'There was an error exporting the campaign coupons, please try again',
};

const members = {
  'members.title': 'Members',
  'members.table.headers.name': 'Name',
  'members.table.headers.phoneNumber': 'Phone Number',
  'members.table.headers.birthday': 'Birthday',
  'members.table.headers.gender': 'Gender',
  'members.table.headers.city': 'City',
  'members.table.headers.totalScanned': 'Total Scanned',
  'members.input.search.placeholder': 'Search for members...',
  'members.table.emptyText': 'No Members',
  'members.notification.error.title': 'Error',
  'members.notification.fetch.error': 'There was an error fetching the members, please try again',
  'members.notification.pagination.noData.title': 'No Data',
  'members.notification.pagination.noData.description': 'No more data on the next page',
  'members.notification.pagination.error':
    'There was an error fetching the members from requested page, please try again',
  'members.filter.notification.dateFromGreaterThanDateTo.error':
    'Date from cannot be greater than date to',
  'members.filter.notification.noData.desription':
    'There were no filtered users, please try again after some time',
  'members.filter.notification.filter.description':
    'There was an error filtering members, please try again',
  'members.filter.notification.error.title': 'Error',
  'members.filter.title': 'Filter',
  'members.filter.form.item.dateFrom.label': 'From',
  'members.filter.form.item.dateFrom.placeholder': 'Select date',
  'members.filter.form.item.dateTo.label': 'To',
  'members.filter.form.item.dateTo.placeholder': 'Select date',
  'members.filter.button.cancel': 'Cancel',
  'members.filter.button.filter': 'Filter',
  'members.filter.form.validation.dateFrom.required': 'Date is required',
  'members.filter.form.validation.dateTo.required': 'Date is required',
};

const winners = {
  'winners.title': 'Members',
  'winners.table.headers.name': 'Name',
  'winners.table.headers.phoneNumber': 'Phone Number',
  'winners.table.headers.birthday': 'Birthday',
  'winners.table.headers.gender': 'Gender',
  'winners.table.headers.city': 'City',
  'winners.table.headers.totalScanned': 'Total Scanned',
  'winners.table.headers.totalGifts': 'Total Gifts',
  'winners.table.headers.status': 'Status',
  'winners.table.headers.claimedGifts': 'Claimed',
  'winners.table.headers.lastGiftWon': 'Last Gift Won',
  'winners.input.search.placeholder': 'Search for winners...',
  'winners.input.searchCoupon.placeholder': 'Search for coupons...',
  'winners.searchCoupon.title': 'Search Coupon',
  'winners.searchCoupon.descriptions.winningGiftId': 'Winning Gift ID:',
  'winners.searchCoupon.descriptions.userId': 'User ID:',
  'winners.searchCoupon.descriptions.campaignId': 'Campaign ID:',
  'winners.searchCoupon.descriptions.createdAt': 'Created:',
  'winners.searchCoupon.descriptions.dateUsed': 'Date Used:',
  'winners.searchCoupon.descriptions.used': 'Used:',
  'winners.searchCoupon.descriptions.updatedAt': 'Updated:',
  'winners.searchCoupon.buttons.update': 'Set code as unused',
  'winners.gifts.table.headers.title': 'Title',
  'winners.gifts.table.headers.dateWon': 'Date Won',
  'winners.gifts.table.headers.claimed': 'Claimed',
  'winners.gifts.table.emptyText': 'No Gifts',
  'winners.gifts.table.popover.unclaim': 'Are you sure that this gift is not delivered?',
  'winners.gifts.table.popover.claim': 'Are you sure that this gift is delivered?',
  'winners.gifts.table.popover.okText': 'Yes',
  'winners.gifts.table.popover.cancelText': 'No',
  'winners.gifts.title': 'Winner Gifts',
  'winners.table.emptyText': 'No Winners',
  'winners.notification.error.title': 'Error',
  'winners.notification.gifts.fetch.error':
    'There was an error loading winner gifts, please try again',
  'winners.notification.fetch.error': 'There was an error fetching the winners, please try again',
  'winners.notification.refetch.error':
    'There was an error re-fetching the winners, please try again',
  'winners.notification.gifts.claim.error':
    'There was an error setting claim over gift, please try again',
  'winners.notification.pagination.noData.title': 'No Data',
  'winners.notification.pagination.noData.description': 'No more data on the next page',
  'winners.notification.pagination.error':
    'There was an error fetching the winners from requested page, please try again',
  'winners.notification.searchCoupon.error': 'There was an error fetching coupon, please try again',
  'winners.notification.updateCoupon.error': 'There was an error updating coupon, please try again',
  'winners.notification.searchCoupon.noData.title': 'Not Found',
  'winners.notification.searchCoupon.noData.description': 'Coupon not found',
};

const user = {
  'user.dataDeletion.title': 'Data Deletion',
  'user.dataDeletion.form.title': 'Facebook Data Deletion',
  'user.dataDeletion.form.button.confirm': 'Confirm',
  'user.dataDeletion.form.button.delete': 'Delete',
  'user.dataDeletion.form.item.email.placeholder': 'Email',
  'user.dataDeletion.form.item.email.confirmationCode': 'Confirmation Code',
  'user.dataDeletion.form.important.title': 'Important:',
  'user.dataDeletion.form.important.description':
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut earum maiores praesentium magni velit',
  'user.dataDeletion.form.validation.email.required': 'Please enter your email',
  'user.dataDeletion.form.validation.email.valid': 'Please enter a valid email',
  'user.dataDeletion.form.validation.confirmationCode.required':
    'Please enter your confirmation code',
  'user.table.popover.grantAdminRole.title': 'Admin Access',
  'user.table.popover.grantAdminRole.description.email.label': 'Email',
  'user.table.popover.grantAdminRole.description.email.noData': 'No Email',
  'user.table.popover.grantAdminRole.button.giveAccess': 'Give Admin Access',
  'user.table.popover.grantAdminRole.button.revokeAccess': 'Revoke Admin Access',
  'user.table.popover.grantAdminRole.button.cancel': 'Cancel',
  'user.notification.authorization.error.title': 'Authorization',
  'user.notification.authorization.error.description':
    'Unauthorized access, please contact the administrator',
  'user.notification.error.title': 'Error',
  'user.notification.success.title': 'Success',
  'user.notification.grantAdminRole.success': 'Admin Access was successfully granted',
  'user.notification.grantAdminRole.error': 'Error granting admin role, please try again',
  'user.notification.removeAdminRole.success': 'Admin Access was successfully revoked',
  'user.notification.removeAdminRole.error': 'Error revoking admin role, please try again',
};

const about = {
  'about.content.title': 'About us',
  'about.content.description': `PATOS App it's the first local one built for ${
    CopyrightClient[process.env.REACT_APP_CLIENT]
  } ${
    process.env.REACT_APP_CLIENT === ClientType.KS ? 'sh.p.k' : ''
  }\nPATOS provides its clients to be part of rewarding games in different campaigns. Usage of application is very simple.\nAfter registration open potato chips pack, scan the QR Code in it and start the game!`,
};

const messages = {
  ...topBar,
  ...login,
  ...mainMenu,
  ...campaigns,
  ...campaign,
  ...members,
  ...winners,
  ...user,
  ...about,
  ...reports,
};

export default {
  locale: 'en-US',
  localeAntd,
  messages,
};
